<router-outlet (activate)="commonService.changeOfRoutes()"></router-outlet>